import { useMutation } from '@tanstack/react-query';
import { type ComparisonItemsActionRequest } from '../../../types/BaselineMeasurements';
import { baselineMeasurementService } from '../../../Domain/BaselineMeasurements/Services';

type ArchiveItemsResponse = {};

const mutationFn = async (data: ComparisonItemsActionRequest) => {
  const response = await baselineMeasurementService.archiveComparisonItems(data);
  return response.data;
};

export const useArchiveEventsFromComparisonMutation = () => {
  return useMutation<ArchiveItemsResponse, unknown, ComparisonItemsActionRequest>(mutationFn);
};
